<div [ngSwitch]="designType">
<div *ngSwitchCase="DEFAULT_DESIGN_TYPE" class="p-b-14">
    <div class="text-center hidden-xs kamona-icon">
        <app-blue-icons blueIcon="blue-info">
        </app-blue-icons>
    </div>
    <div class="m-t-16">
        <div class="confirm-title">
            {{title}}
        </div>

    </div>
    <div class="m-t-8">
        <div [innerHTML]="confirmText" class="confirm-note">
        </div>

    </div>
    <div class="m-t-16">
        <div class="confirm-divider">
        </div>
    </div>
    <div class="m-t-16">
        <div nz-row nzAlign="middle" nzJustify="space-between">
            <div>
            </div>
            <div>
                <div nz-row nzAlign="middle">
                    <div  (click)="closeModal()" class="confirm-cancel addCursor">Cancel</div>
                    <div>
                        <div class="m-l-24">
                            <button (click)="submit()" [nzLoading]="submitting"
                                    class="btn btn-primary button-size-151"
                                    nz-button>
                                {{confirmButtonText}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
  <div *ngSwitchCase="KAMONA">
   <div class="p-10">
     <div *ngIf="!submitting" style="margin-top: -2em" nz-row nzJustify="space-between">
       <div></div>
       <div>
         <div (click)="closeModal()" class="addCursor">
         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path fill-rule="evenodd" clip-rule="evenodd" d="M5.15152 5.15128C5.62015 4.68265 6.37995 4.68265 6.84858 5.15128L12 10.3027L17.1515 5.15128C17.6202 4.68265 18.3799 4.68265 18.8486 5.15128C19.3172 5.61991 19.3172 6.3797 18.8486 6.84833L13.6971 11.9998L18.8486 17.1513C19.3172 17.6199 19.3172 18.3797 18.8486 18.8483C18.3799 19.317 17.6202 19.317 17.1515 18.8483L12 13.6969L6.84858 18.8483C6.37995 19.317 5.62015 19.317 5.15152 18.8483C4.68289 18.3797 4.68289 17.6199 5.15152 17.1513L10.303 11.9998L5.15152 6.84833C4.68289 6.3797 4.68289 5.61991 5.15152 5.15128Z" fill="black"/>
         </svg>
         </div>
       </div>
     </div>
     <div class="kamona-title">
       {{title}}
     </div>
     <div [innerHTML]="confirmText" class="kamona-note">
     </div>
     <div>
       <div nz-row nzAlign="middle" nzJustify="space-between">
         <div></div>
         <div>
           <div class="m-t-8" nz-row nzAlign="middle">
             <div>
               <button [disabled]="submitting" (click)="closeModal()" class="kamona-cancel">Cancel</button>
             </div>
             <div>
               <button (click)="submit()" class="kamona-btn" [nzLoading]="submitting" nz-button>
                 {{confirmButtonText}}
               </button>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
  </div>
</div>
